(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["louna-product-card"] && !Shopify.designMode) return;
  try {
    function lounaSetCardImage(card, url) {
  const image = card.querySelector('.louna-product-photo');
  if (!image || !url) return;
  image.removeAttribute('srcset');
  image.src = url;
}
document.addEventListener('click', function(event) {
  const thumb = event.target.closest('[data-louna-image]');
  if (thumb) lounaSetCardImage(thumb.closest('[data-louna-card]'), thumb.dataset.lounaImage);
});
document.addEventListener('change', function(event) {
  if (!event.target.matches('.louna-color-radio')) return;
  const card = event.target.closest('[data-louna-card]');
  if (!card) return;
  const variant = card.querySelector('[data-variant-id="' + event.target.value + '"]');
  if (!variant) return;
  card.querySelector('[data-louna-price]').textContent = variant.dataset.price;
  if (variant.dataset.image) lounaSetCardImage(card, variant.dataset.image);
  card.querySelectorAll('[data-louna-product-link]').forEach(function(link) { link.href = variant.dataset.url; });
});
  } catch(e) { console.error(e); }
})();

})();
